"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var Text = require('../text/text');

var BUTTON_SKINS = {
  STANDARD: 'standard',
  PREMIUM: 'premium'
};
var BUTTON_SIZES = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium'
};
var BUTTON_WEIGHTS = {
  NORMAL: 'normal',
  THIN: 'thin'
};

var TextButton = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TextButton, _React$PureComponent);

  var _super = _createSuper(TextButton);

  function TextButton() {
    _classCallCheck(this, TextButton);

    return _super.apply(this, arguments);
  }

  _createClass(TextButton, [{
    key: "_addAffix",
    value: function _addAffix(Affix, skin, disabled) {
      return Affix && /*#__PURE__*/React.createElement("span", {
        className: "control-text-button skin-".concat(skin),
        disabled: disabled
      }, Affix);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          skin = _this$props.skin,
          children = _this$props.children,
          size = _this$props.size,
          weight = _this$props.weight,
          getClassName = _this$props.getClassName,
          shouldTranslate = _this$props.shouldTranslate,
          prefixIcon = _this$props.prefixIcon,
          suffixIcon = _this$props.suffixIcon;
      var textSkin = skin === BUTTON_SKINS.STANDARD ? 'link' : skin;
      var className = getClassName('control-text-button');
      var prefixClassName = getClassName('prefix');
      var suffixClassName = getClassName('suffix');
      return /*#__PURE__*/React.createElement("button", {
        className: className,
        "data-hook": dataHook,
        disabled: disabled,
        onClick: onClick
      }, /*#__PURE__*/React.createElement("div", {
        className: prefixIcon && prefixClassName
      }, this._addAffix(prefixIcon, skin, disabled)), /*#__PURE__*/React.createElement(Text, {
        disabled: disabled,
        size: size,
        skin: textSkin,
        weight: weight,
        shouldTranslate: shouldTranslate
      }, children), /*#__PURE__*/React.createElement("div", {
        className: suffixIcon && suffixClassName
      }, this._addAffix(suffixIcon, skin, disabled)));
    }
  }]);

  return TextButton;
}(React.PureComponent);

TextButton.displayName = displayNames.TEXT_BUTTON;
TextButton.propTypes = {
  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** content to be displayed */
  children: PropTypes.any,

  /** Applies disabled styles and behaviour */
  disabled: PropTypes.bool,

  /** Triggered when button is clicked */
  onClick: PropTypes.func,

  /** Skin of TextButton  */
  skin: PropTypes.oneOf(Object.values(BUTTON_SKINS)),

  /** Size of TextButton */
  size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),

  /** Weight of TextButton */
  weight: PropTypes.oneOf(Object.values(BUTTON_WEIGHTS)),

  /** Icon to be places before the text */
  prefixIcon: PropTypes.node,

  /** Icon to be places after the text */
  suffixIcon: PropTypes.node
};
TextButton.defaultProps = {
  skin: BUTTON_SKINS.STANDARD,
  size: BUTTON_SIZES.MEDIUM,
  weight: BUTTON_WEIGHTS.NORMAL,
  enableEllipsis: true
};
module.exports = compose(TextButton);